import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Orders/Handlers/LoadOrderByOrderNumber";

// Insite's GetOrderMapper hydrates ShipmentPackage.ShipmentPackageLineDtos only when
// the literal token "shipments/shipmentpackagelines" is present in the expand list.
// Stock LoadOrderByOrderNumber only requests "orderLines" + "shipments", so SPLs
// arrive null and the order-details widget can't render shipped items. The blueprint
// replacement plugin only retargets content-library/mobius imports, so an Overrides/
// file cannot replace this client-framework handler — we modify the chain directly.
const AddShipmentPackageLinesExpand: typeof PopulateApiParameter = props => {
    const existing = props.apiParameter.additionalExpands ?? [];
    if (!existing.some(s => s.toLowerCase() === "shipments/shipmentpackagelines")) {
        props.apiParameter = {
            ...props.apiParameter,
            additionalExpands: [...existing, "shipments/shipmentpackagelines"],
        };
    }
};

addToChainAfter(chain, PopulateApiParameter, AddShipmentPackageLinesExpand);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
